module.exports = __webpack_public_path__ + "img/sale-rank3.c63cfe5b.png";